import { useEffect, useRef } from 'react';

export const useMountedRef = () => {
    const isMounted = useRef(true);

    useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);

    return isMounted;
};